import axios from './axiosService';

export default {
  renderSnippet(faxSnippetID, faxContactID, messageUUID) { // MLD-3985
    const options = {
      params: {
        message_uuid: messageUUID,
      }
    }
    return axios.get(`/api/fax/snippets/${faxSnippetID}/render/${faxContactID}`, options)
      .then(response => response.data);
  },
  getFormFields() { // MLD-3985
    return {
      salutation: '',
      first_name: '',
      last_name: '',
      designation: '',
      npi: '',
      company_name: '',
      fax_number: '',
      address1: '',
      address2: '',
      locality: '',
      administrative_area: '',
      postal_code: '',
      country: 'USA',
      status: 'Active',
    }
  },
  populateForm(form, data) { // MLD-3985
    form.salutation = data.salutation;
    form.first_name = data.first_name;
    form.last_name = data.last_name;
    form.designation = data.designation;
    form.npi = data.npi;
    form.company_name = data.company_name;
    form.fax_number = data.fax_number;

    form.address1 = data.address1;
    form.address2 = data.address2;
    form.locality = data.locality;
    form.administrative_area = data.administrative_area;
    form.postal_code = data.postal_code;
    form.country = data.country;
    form.status = data.status;
  },
  async synchronizeContacts() { // MLD-6662
    return axios.post(`/api/fax/contacts/synchronize`)
      .then(response => response.data);
  },
  async getContacts(params = {}) {
    return axios.get(`/api/fax/contacts`, {params})
      .then(response => response.data);
  },
  async getContact(contactID) {
    return axios.get(`/api/fax/contacts/${contactID}`)
      .then(response => response.data);
  },
  async createContact(form) {
    return form.post(`/api/fax/contacts`)
      .then(response => response.data);
  },
  async updateContact(contactID, form) {
    return form.put(`/api/fax/contacts/${contactID}`)
      .then(response => response.data);
  },
  async deleteContact(contactID) {
    return axios.delete(`/api/fax/contacts/${contactID}`)
      .then(response => response.data);
  },
  async unsubscribeCode(form) {
    return form.post(`/api/fax/unsubscribe`)
      .then(response => response.data);
  },
  async unsubscribeContact(contactID) {
    return axios.post(`/api/fax/contacts/${contactID}/unsubscribe`)
      .then(response => response.data);
  },
  async resubscribeContact(contactID) {
    return axios.post(`/api/fax/contacts/${contactID}/resubscribe`)
      .then(response => response.data);
  },
  async getMessages(params = {}) {
    return axios.get(`/api/fax/messages`, {params})
      .then(response => response.data);
  },
  async getMessage(messageID) {
    return axios.get(`/api/fax/messages/${messageID}`)
      .then(response => response.data);
  },
  async getEvents(messageID) { // MLD-6678
    return axios.get(`/api/fax/messages/${messageID}/events`)
      .then(response => response.data);
  },
  async send(form) {
    return axios.post(`/api/fax/send`, form)
      .then(response => response.data);
  },
  async getActiveFaxSnippets() { // MLD-3963
    return this.getFaxSnippets({is_active: true});
  },
  async getFaxSnippets(params = {}) {
    return axios.get(`/api/fax/snippets`, {params})
      .then(response => response.data);
  },
  async getFaxSnippet(snippetID) {
    return axios.get(`/api/fax/snippets/${snippetID}`)
      .then(response => response.data);
  },
  async createFaxSnippet(form) {
    return form.post(`/api/fax/snippets`)
      .then(response => response.data);
  },
  async updateFaxSnippet(snippetID, form) {
    return form.put(`/api/fax/snippets/${snippetID}`)
      .then(response => response.data);
  },
  async deleteFaxSnippet(snippetID) {
    return axios.delete(`/api/fax/snippets/${snippetID}`)
      .then(response => response.data);
  },
}
